import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerifyPatientComponent } from './component/verify-patient/verify-patient.component';
import { HomeComponent } from './registrationComponents/home/home.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/patient/verifypatient',
    pathMatch: 'full'
  },
  {
    path: 'patient',
    component: VerifyPatientComponent
  },
  {
    path: 'home',
    //loadChildren: () => import('./registrationComponents/registration.module').then(m => m.RegistrationModule)
    component:HomeComponent
  },
  {
    path: 'madison',
    loadChildren: () => import('../app/MedisonMedical/medisonmedical/medisonmedical.module').then(m => m.MedisonmedicalModule)
  }
 ,{
  path: 'intake',
  loadChildren: () => import('../app/component/intakemodule/intakemodule.module').then(m => m.IntakemoduleModule)
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
